export default "__VITE_ASSET__BYtU51jS__"